import React from 'react';
import DetailWrapper from '../../CardRow/DetailWrapper';
import SectionWrapper from '../../CardRow/SectionWrapper';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import TextWrapper from '../../CardRow/TextWrapper';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import CustomLink from '../../CustomizedComponents/CustomLink';

const IconWrapper = styled.div`
  display: inline-flex;
`;

const TextArea = styled.div`
  display: inline-flex;
  align: justify-content;
  margin-left: 20px;
`;

const Links = () => {
  const linkPath = '/pricealert';
  return (
    <>
      <DetailWrapper>
        <SectionWrapper>
          <IconWrapper>
            <HelpOutlineIcon />
          </IconWrapper>
          <TextArea>
            <TextWrapper>
              <FormattedMessage id={'app.settings.prices.text'} />
              {' '}
              <CustomLink text={'app.settings.prices.link'} path={linkPath} />
            </TextWrapper>
          </TextArea>
        </SectionWrapper>
      </DetailWrapper>
    </>
  );
};

Links.propTypes = {};

export default Links;
